import { render, staticRenderFns } from "./CustomsComment.vue?vue&type=template&id=d133c206&scoped=true&"
import script from "./CustomsComment.vue?vue&type=script&lang=js&"
export * from "./CustomsComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d133c206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d133c206')) {
      api.createRecord('d133c206', component.options)
    } else {
      api.reload('d133c206', component.options)
    }
    module.hot.accept("./CustomsComment.vue?vue&type=template&id=d133c206&scoped=true&", function () {
      api.rerender('d133c206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Ui/CustomsComment.vue"
export default component.exports